import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";
import {Card, Typography, Box, useMediaQuery} from "@mui/material";
import CardContent from "@mui/material/CardContent";
import {MessageSquare, MessageSquareText, X, Check, UserRound, Eye} from "lucide-react";
import {getDisplayTime} from "../../../config/values";
import TicketButton from "./TicketButton";
import GetConfirmationText from "../../components/elements/GetConfirmationText";
import axios from "axios";
import {defaultVariables} from "../../../config";
import {useSnackbar} from "notistack";
import {Link} from "react-router-dom";
import {theme} from "../../../config/design/theme";

function SingleTicketListItem({item,reload,role}){
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const token = localStorage.getItem("ACT");
    const [submitLoading, setSubmitLoading] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));


    const handleCloseTicket = async () => {
        await setSubmitLoading(true);
        const data = new FormData();
        data.append("list_id", item.id);
        try {
            await axios.post(`${defaultVariables.url}/tickets/close-list`,data, {
                headers: { Authorization: `Bearer ${token}` },
            });
        }catch (e) {
            enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });

        }
        await setSubmitLoading(false);
        if(!!reload){
            reload();
        }
    }
    return (
        <Box className='bg-gray-box flex-space flex-column-xl'>

            {
                !isMobile ?
                <>
                   <div style={{minWidth: !isMobile ? 280 : "unset" }}>
                       <div className='flex-direction'>
                           <MessageSquare/>
                           {item.unique_code}
                       </div>
                           {

                               role === "admin"  &&
                               <div className='flex-direction mt-10'>
                                   <UserRound/>
                                   <Link to={`/panel/manage/users/edit/${item.user?.id}`}>{item.user?.first_name} {item.user?.last_name}</Link>
                               </div>
                           }

                   </div>
                    {
                        item.unread_count > 0 ?
                            <Typography className='reply-ticket-status active'>{t("unread")}{item.unread_count}</Typography>
                            :
                            <Typography className='reply-ticket-status'>{t("unread")}{item.unread_count}</Typography>
                    }
                </>
                    :
                 <>
                     {

                         role === "admin"  &&
                         <div className='flex-direction mb-10'>
                             <UserRound/>
                             <Link to={`/panel/manage/users/edit/${item.user?.id}`}>{item.user?.first_name} {item.user?.last_name}</Link>
                         </div>
                     }
                     <div className="flex-space w100">

                         <div className='flex-direction'>
                             <MessageSquare/>
                             {item.unique_code}
                         </div>
                         {
                             item.unread_count > 0 ?
                                 <Typography className='reply-ticket-status active'>{t("unread")}{item.unread_count}</Typography>
                                 :
                                 <Typography className='reply-ticket-status'>{t("unread")}{item.unread_count}</Typography>
                         }
                     </div>
                 </>
            }
            {
                !isMobile ?
                    <>
                        <p style={{fontSize:13}}>{getDisplayTime(item.created_at)}</p>
                        <div className='flex-direction'>
                            <TicketButton
                                color={!!item.is_closed ? 'text' : 'secondary'}
                                variant='outlined'
                                list_id={item.id}
                                title={!!item.is_closed ? t('view') : t('chat')}
                                icon={!!item.is_closed ? <Eye/> : <MessageSquareText/>}
                                reload={reload}
                                is_closed={item.is_closed}
                            />
                            {
                                item.is_closed ?
                                    <Typography align="center" style={{minWidth:125}}>{t('closed')}</Typography>
                                    :
                                    <GetConfirmationText
                                        tooltip={t('closeTicket')}
                                        handleAction={handleCloseTicket}
                                        startIcon={<X className="lucide-icon"/>}
                                        icon={<Check className="lucide-icon"/>}
                                        buttonColor="primary"
                                        variant="outlined"
                                        loading={submitLoading}
                                    >
                                        {t('closeTicket')}
                                    </GetConfirmationText>

                            }
                        </div>
                    </>
                    :
                    <div className="flex-space w100 mt-10 flex-column-small">
                        <p style={{fontSize:13}}>{getDisplayTime(item.created_at)}</p>
                        <div className='flex-direction'>
                            <TicketButton
                                color={!!item.is_closed ? 'text' : 'secondary'}
                                variant='outlined'
                                list_id={item.id}
                                title={!!item.is_closed ? t('view') : t('chat')}
                                icon={!!item.is_closed ? <Eye/> : <MessageSquareText/>}
                                reload={reload}
                                is_closed={item.is_closed}
                            />
                            {
                                item.is_closed ?
                                    <Typography align="center" style={{minWidth:125}}>{t('closed')}</Typography>
                                    :
                                    <GetConfirmationText
                                        tooltip={t('closeTicket')}
                                        handleAction={handleCloseTicket}
                                        startIcon={<X className="lucide-icon"/>}
                                        icon={<Check className="lucide-icon"/>}
                                        buttonColor="primary"
                                        variant="outlined"
                                        loading={submitLoading}
                                    >
                                        {t('closeTicket')}
                                    </GetConfirmationText>

                            }
                        </div>
                    </div>

            }



        </Box>

    );
}
export default withStyles(Styles)(SingleTicketListItem);
